module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-background",
    class: _vm.mainBackgroundClass
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-col-landing"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("\n        Helping Children Impacted by Trauma to Heal and Thrive\n      ")]), _vm._v(" "), _c('p', [_vm._v("Exposure to violence in the community or at home can impact students psychologically, socially, academically, and\n        behaviorally. It often results in trauma, diminished health outcomes, low academic achievement, classroom management\n        issues and a hastened dispatch to child welfare or juvenile justice system--particularly for students of color.")]), _vm._v(" "), _c('p', [_vm._v("\n        While the issue of children’s exposure to violence and trauma is not new for schools, there are now even more promising practices\n        that can help our schools do what they do best - educate.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "nav-button-wrapper",
    on: {
      "click": _vm.closeLanding
    }
  }, [_c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": " float-right call-to-action-blue"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "loading-overlay",
    class: _vm.loadingOverlayClass
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-col"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("WELCOME TO THE CHANGING MINDS ONLINE MODULE")]), _vm._v(" "), _c('img', {
    staticClass: "main-image",
    attrs: {
      "src": "https://s3-us-west-2.amazonaws.com/futures-vpv/futures-1.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links-underlay"
  }, [_c('img', {
    staticClass: "group-image",
    attrs: {
      "src": "https://s3-us-west-2.amazonaws.com/futures-vpv/Group.png"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "link-left",
    attrs: {
      "href": "http://www.discoveryeducation.com/",
      "target": "blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "link-right",
    attrs: {
      "href": "https://changingmindsnow.org/",
      "target": "blank"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36be98bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/landingFirst.vue
// module id = 609
// module chunks = 1